import { PropsWithChildren } from 'react'

import { Typography } from '@themenu/design-system'

import { useIsMobile } from '../../hooks/useIsMobile'

export const Title = ({ children }: PropsWithChildren): JSX.Element => {
  const isMobileScreen = useIsMobile()
  return (
    <Typography align="center" variant={isMobileScreen ? 'headline' : 'h2'} display="block">
      {children}
    </Typography>
  )
}
